import { initialState, ContractTemplateState } from "./state";
import { Actions } from './actions';
import {
    SET_CONTRACT_TEMPLATE_LIST, SET_CONTRACT_TEMPLATE_BY_ID, ADD_CONTRACT_TEMPLATE_RESPONSE,
    UPDATE_CONTRACT_TEMPLATE_RESPONSE, DELETE_CONTRACT_TEMPLATE_RESPONSE
} from "./actionTypes";

import { SortListAscending } from 'app/utils/sort.util';

export function ContractTemplateReducer(state = initialState, action: Actions): ContractTemplateState {
    switch (action.type) {
        case SET_CONTRACT_TEMPLATE_LIST:
            return Object.assign({}, state, {
                contractTemplateList: SortListAscending(action.payload, "name")
            });
        case SET_CONTRACT_TEMPLATE_BY_ID:
            return Object.assign({}, state, {
                contractTemplateById: action.payload
            });
        case ADD_CONTRACT_TEMPLATE_RESPONSE:
            return Object.assign({}, state, {
                addContractTemplateResponse: action.payload
            });
        case UPDATE_CONTRACT_TEMPLATE_RESPONSE:
            return Object.assign({}, state, {
                updateContractTemplateResponse: action.payload
            });
        case DELETE_CONTRACT_TEMPLATE_RESPONSE:
            return Object.assign({}, state, {
                deleteContractTemplateResponse: action.payload
            });
        default:
            return state;
    }
}
